const styles = `:host(:not([hidden])){color:var(--goto-type-color-secondary);width:100%;display:block;box-sizing:border-box!important}`;export default styles;